import { Link } from 'react-router-dom';

export default function Footer() {
  const handleTopNavigation = (href: string) => {
    if (href === '/') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-emerald-900 via-teal-900 to-emerald-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🍑</span>
              <span className="font-bold text-lg text-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                株式会社Peach
              </span>
            </div>
            <p className="text-emerald-200 text-sm leading-relaxed">
              フレッシュな発想で<br />
              ビジネスに新しい価値を。<br />
              大阪発のITカンパニー。
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-emerald-400 uppercase mb-4">Contact</h4>
            <p className="text-emerald-200 text-sm mb-2">お気軽にご相談ください</p>
            <p className="text-emerald-200 text-sm mb-1">090-6901-0787</p>
            <p className="text-emerald-200 text-sm mb-3 break-all">accounting@peach-sys.com</p>
            <Link
              to="/contact"
              onClick={() => handleTopNavigation('/contact')}
              className="inline-flex items-center gap-2 text-white text-sm font-medium hover:text-pink-300 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              お問い合わせフォームへ
            </Link>
          </div>

          {/* Sitemap */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-emerald-400 uppercase mb-4">Sitemap</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: 'ホーム', href: '/' },
                { label: 'サービス', href: '/services' },
                { label: '料金プラン', href: '/plans' },
                { label: '会社概要', href: '/about' },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    onClick={() => handleTopNavigation(item.href)}
                    className="text-emerald-200 text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-emerald-400 uppercase mb-4">Legal</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: 'プライバシーポリシー', href: '/privacy' },
                { label: 'お問い合わせ', href: '/contact' },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    onClick={() => handleTopNavigation(item.href)}
                    className="text-emerald-200 text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Big Brand Text */}
        <div className="border-t border-emerald-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-emerald-500 text-xs">
            © {new Date().getFullYear()} 株式会社Peach. All rights reserved.
          </p>
          <p className="text-emerald-500 text-xs">
            大阪府大阪市浪速区敷津西１－５－２０ ラフィナート７０４号室
          </p>
        </div>

        {/* Large PEACH text */}
        <div className="mt-6 overflow-hidden">
          <p
            className="text-center font-black tracking-tighter text-emerald-800/40 select-none"
            style={{ fontSize: 'clamp(3rem, 12vw, 9rem)', fontFamily: "'Playfair Display', serif", letterSpacing: '-0.05em' }}
          >
            PEACH
          </p>
        </div>
      </div>
    </footer>
  );
}
